import React, { useEffect } from 'react';
import { Form } from 'antd';
import ChangePasswordForm from 'app/auth/components/ChangePasswordForm';
import { StyledButtonLogin, StyledButtonBlueUnbordered, StyledButtonGroupRight } from 'components/styledComponents/button/Button.styled';
import { Info } from 'shared/ui';
import { authApi } from 'app/auth/api';
import { setPasswordExpired } from 'app/auth/slices';
import { StyledPasswordExpired, StyledPasswordWrapper, StyledExpiredForm } from 'app/auth/components/Login.styled';
import { LoginData } from 'app/auth/types';
import { HandleSubmitType } from './Login';

const { useChangeExpiredPasswordMutation } = authApi;

interface ExpirePasswordProps {
  changeEndedStatus: (status: boolean) => void;
  endedStatus?: boolean;
  handleSubmit: HandleSubmitType;
  data: Partial<LoginData>;
  setData: (data: Partial<LoginData>) => void;
  loginForm: { setFieldsValue: (fields: object) => void };
}

const ExpirePassword = ({
  changeEndedStatus, endedStatus = false, handleSubmit, data, setData, loginForm,
}: ExpirePasswordProps) => {
  const [form] = Form.useForm();
  const { getFieldsValue } = form;

  const [changeExpiredPassword] = useChangeExpiredPasswordMutation();

  const handleChange = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    form.validateFields().then((values: { oldPassword: string; newPassword: string }) => {
      const { oldPassword, newPassword } = values;
      changeExpiredPassword({
        oldPassword,
        newPassword,
        email: data?.userName,
      });
    });
  };

  useEffect(() => {
    if (endedStatus) {
      const { newPassword: password } = getFieldsValue();
      handleSubmit(undefined, { password });
      changeEndedStatus(false);
    }
  }, [changeEndedStatus, endedStatus, form, getFieldsValue, handleSubmit]);

  const handleBack = () => {
    loginForm.setFieldsValue({ password: '', userName: '' });
    setData({});
    setPasswordExpired(false);
  };

  return (
    <StyledPasswordWrapper>
      <StyledPasswordExpired>
        <Info content="Your password has expired. Please, change your password." />
      </StyledPasswordExpired>
      <StyledExpiredForm>
        <ChangePasswordForm form={form} translatable={false} />
      </StyledExpiredForm>
      <StyledButtonGroupRight>
        <StyledButtonBlueUnbordered onClick={handleBack}>Back</StyledButtonBlueUnbordered>
        <StyledButtonLogin $isMarginLeft onClick={handleChange}>
          Change and Log In
        </StyledButtonLogin>
      </StyledButtonGroupRight>
    </StyledPasswordWrapper>
  );
};

export default ExpirePassword;
